import { onDocumentEvent } from '@app/utils/domHelpers'

const showUsageSummary = (e) => {
  const dataType = e.target.dataset.walkthroughId
  const icon = document.querySelector(`[data-behaviour="${dataType}-icon"]`)

  const table = document.querySelector(`[data-behaviour="${dataType}-details"]`)

  const labelText = document.querySelector(
    `[data-behaviour="show-${dataType}-usage"]`
  )

  if (dataType === 'hub-data') {
    const otherDetails = document.querySelector(
      '[data-behaviour="content-data-details"]'
    )
    if (otherDetails && otherDetails.style.display === 'block') {
      otherDetails.style.display = 'none'
      document.querySelector(
        `[data-behaviour='show-content-data-usage']`
      ).innerText = I18n.t('firms.internal_invoices.show_details')
      const iconOther = document.querySelector(
        `[data-behaviour='content-data-icon']`
      ).classList
      iconOther.remove('fa-angle-up')
      iconOther.add('fa-angle-down')
    }
  } else {
    const otherDetails = document.querySelector(
      '[data-behaviour="hub-data-details"]'
    )
    if (otherDetails && otherDetails.style.display === 'block') {
      otherDetails.style.display = 'none'
      document.querySelector(
        `[data-behaviour='show-hub-data-usage']`
      ).innerText = I18n.t('firms.internal_invoices.show_details')
      const iconOther = document.querySelector(
        `[data-behaviour='hub-data-icon']`
      ).classList
      iconOther.remove('fa-angle-up')
      iconOther.add('fa-angle-down')
    }
  }

  if (table.style.display === 'none') {
    table.style.display = 'block'
    icon.classList.remove('fa-angle-down')
    icon.classList.add('fa-angle-up')
    labelText.innerText = I18n.t('firms.internal_invoices.hide_details')
  } else {
    table.style.display = 'none'
    icon.classList.remove('fa-angle-up')
    icon.classList.add('fa-angle-down')
    labelText.innerText = I18n.t('firms.internal_invoices.show_details')
  }
}

export default () => {
  const hubUsageExpandListener = onDocumentEvent(
    document,
    'click',
    '[data-behaviour="show-hub-data-usage"], [data-behaviour="show-content-data-usage"], [data-behaviour="hub-data-icon"], [data-behaviour="content-data-icon"]',
    showUsageSummary
  )

  return () => {
    hubUsageExpandListener()
  }
}
